

exports.__esModule = true;
var _exportNames = {
  $xoShippingOptions: true
};
exports.$xoShippingOptions = void 0;
var _directive = require("./component/directive.js");
exports.$xoShippingOptions = _directive.$xoShippingOptions;
var _lib = require("./lib");
Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _lib[key]) return;
  exports[key] = _lib[key];
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-shipping-options/src/index.js
// module id = ../node_modules/xo-shipping-options/src/index.js
// module chunks = 0